/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
import React, { useRef } from 'react';

import { RankingItem } from '../../pages/stackRank/types';
import { useScrollIntoParentIfSelected } from '../../utils/useScrollIntoParentIfSelected';
import { metricValueFormat } from '../../utils/metricValueFormat';
import TruncatedText from '../../utils/TruncatedText';
import { STACK_RANK_SELECTED_EMPLOYEE_COLOR } from '../../utils/stackRankColors';
import './rankingCard.scss';

interface RankingCardProps extends RankingItem {
    selectedMetric?: string;
    is_logged_in_user?: boolean;
    // P4P multi-tier (E20-6317). isTiered gates whether the metric-driven color applies at all;
    // selectedMetricColor is the actual resolved hex for the currently selected metric's color
    // family (StackRankBandColors[colorIndex].meets - see StackRank.tsx), so this card's selected
    // highlight matches the chart/grid instead of using one fixed color regardless of metric.
    isTiered?: boolean;
    selectedMetricColor?: string;
}
const RankingCard: React.FC<RankingCardProps> = ({
    employee_name,
    metricType,
    metric_value,
    metric_rank,
    selected,
    looged_in_user,
    selectedMetric,
    is_logged_in_user,
    isTiered,
    selectedMetricColor,
}) => {
    const cardRef = useRef<HTMLDivElement>(null);

    useScrollIntoParentIfSelected(cardRef, selected, 5, [metric_value, metric_rank, selectedMetric]);


    const isLoggedInUser = is_logged_in_user || employee_name.includes(looged_in_user ?? '');
    const isSelected = selected === true;

    // Only the selected case changes color for a tiered scorecard - the logged-in-user-but-not-
    // selected background stays the existing indigo, confirmed explicitly not to change.
    let backgroundColor;
    if (isSelected) {
        if (isTiered) {
            backgroundColor = selectedMetricColor || STACK_RANK_SELECTED_EMPLOYEE_COLOR;
        } else {
            backgroundColor = isLoggedInUser
                ? 'rgba(107, 111, 243, 1)'
                : 'rgba(0, 214, 187, 1)';
        }
    } else if (isLoggedInUser) {
        backgroundColor = 'rgba(107, 111, 243, 1)';
    }

    const cardClass = (isSelected || isLoggedInUser) ? 'RankingCard-selected' : 'RankingCard-un-selected';
    const extractedName = employee_name.substring(0, employee_name.indexOf('('))?.trim();
    const nameDisplay = extractedName === "Anonymous" ? employee_name : extractedName;

    return (
        <div
            className={cardClass}
            key={employee_name}
            ref={cardRef}
            style={backgroundColor ? { backgroundColor } : undefined}
        >
            <div style={(isSelected || isLoggedInUser) ? { color: 'white', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' } 
            : { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ fontSize: 'large', display: 'flex', alignItems: 'center' }}>
                    {metric_rank} &nbsp;&nbsp;
                    <img src="/userIcon.png" height={30} width={30} alt="user" />
                    &nbsp;
                    {/* {isSelected ? (
                        <strong>{nameDisplay}</strong>
                    ) : (
                        <span style={{ fontWeight: 400 }}>{nameDisplay}</span>
                    )} */}

                    {(isSelected || isLoggedInUser) ? (
                        <strong>
                            <TruncatedText text={nameDisplay} maxLength={25} />
                        </strong>
                    ) : (
                        <TruncatedText
                            text={nameDisplay}
                            maxLength={25}
                            style={{ fontWeight: 400 }}
                        />
                    )}
                </div>
                <div>
                    <p style={{ margin: 0 }}>{metricValueFormat(metric_value, metricType ?? '')}</p>
                </div>
            </div>
        </div>
    );
};

export default RankingCard;
